import { CdkDrag } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '@environment';
import { AppService, MlPlayerService, MlTrackingService } from '@services';
import { SceneStore } from '@stores';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, CdkDrag, CommonModule, FormsModule],
})
export class HeaderComponent {
  appService = inject(AppService);
  #mlPlayerService = inject(MlPlayerService);
  mlTrackingService = inject(MlTrackingService);
  sceneStore = inject(SceneStore);

  environment = environment;

  selectDemoMovie(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      this.appService.demoMode.set(true);
      this.appService.sampleMovie.set(URL.createObjectURL(file));
    }
    (event.target as HTMLInputElement).value = '';
  }

  async selectTracking(event: Event) {
    this.appService.demoMode.set(true);
    const files = (event.target as HTMLInputElement).files;
    this.#mlPlayerService.loadFiles(files);
    (event.target as HTMLInputElement).value = '';
  }

  removeDemoMovie() {
    this.setCameraId();
    this.appService.demoMode.set(false);
    this.appService.sampleMovie.set(null);
  }

  setCameraId() {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      const videoInputs = devices
        .filter((device) => device.kind === 'videoinput')
        .map((device) => ({
          label: device?.label,
          id: device.deviceId,
        }))
        .reverse();
      if (videoInputs.find((camera) => camera.label === 'Back Camera')) {
        this.appService.cameraId.set(
          videoInputs.find((camera) => camera.label === 'Back Camera').id,
        );
      } else {
        this.appService.cameraId.set(videoInputs[0].id);
      }
    });
  }

  stopTrackingMode(): void {
    this.appService.trackingMode.set(false);
    this.appService.demoMode.set(false);
    this.appService.sampleMovie.set(null);
  }
}
